import React from 'react';
import { Svg } from './Svg';

const Back = (props) => <Svg viewBox='0 0 16 24' path={
    <>
        <path d='M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z'/>
    </>} {...props} />;

export { Back };
